var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('team-form',{attrs:{"title":_vm.$t('string.edit_team')}})}
var staticRenderFns = []

export { render, staticRenderFns }